import { Box, Button, Typography, useTheme } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { tokens } from '../../../../global/theme/tokens';
import CodeIcon from '@mui/icons-material/Code';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

export const TemplateBlock = ({ data, onSelect, onEdit, onCodeEdit }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  const { label, key, types } = data;

  return (
    <Box
      className="w-full flex-col gap-2 overflow-hidden rounded-lg"
      sx={{
        border: `1px solid ${colors.card}`,
        '.edit-button': {
          transform: 'translateY(100%)',
          opacity: 0,
          transition: 'all 0.3s ease',
        },
        ':hover .edit-button': {
          transform: 'translateX(0%)',
          opacity: 1,
        },
      }}
    >
      <Box
        className="w-full px-4 py-2"
        onClick={() => onSelect && onSelect(data)}
      >
        <Typography fontWeight={500}>{label}</Typography>
        <Typography className="opacity-50 italic pl-2">{key}</Typography>
      </Box>
      <Box className="flex w-full justify-between">
        {onCodeEdit && (
          <Button
            onClick={(e) => onCodeEdit(data)}
            className="edit-button"
            sx={{
              bgcolor: colors.success + '30',
              border: `1px solid ${colors.success}80`,
              ':hover': {
                bgcolor: colors.success,
                border: `1px solid ${colors.success}`,
              },
            }}
          >
            <CodeIcon />
          </Button>
        )}
        {onEdit && (
          <Box className="flex gap-2">
            <Button
              onClick={(e) => onEdit({ value: data.value, types: data.types })}
              className="edit-button"
              sx={{
                bgcolor: colors.info + '30',
                border: `1px solid ${colors.info}80`,
                ':hover': {
                  bgcolor: colors.info,
                  border: `1px solid ${colors.info}`,
                },
              }}
            >
              <ContentCopyIcon />
            </Button>
            <Button
              onClick={(e) => onEdit(data)}
              className="edit-button"
              sx={{
                bgcolor: colors.info + '30',
                border: `1px solid ${colors.info}80`,
                ':hover': {
                  bgcolor: colors.info,
                  border: `1px solid ${colors.info}`,
                },
              }}
            >
              <EditIcon />
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  );
};
